import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.PopupFooter', {
    skip: 'Skip this step',
    back: 'Choose a different system to connect',
});
